import { useMemo } from 'react';

import { useStudentGroupAttendanceQuery } from 'core/graphql';

import { transformMyAttendance } from './transform';
import type { IMyAttendance } from './transform';

interface IUseMyAttendance {
  attendance: IMyAttendance;
  loading: boolean;
  error: string;
}

/**
 * The signed-in student's own attendance for one group.
 *
 * The teacher has always recorded this (and even sees Zoom join-time chips in
 * the journal), but none of it ever reached the student — they could not answer
 * "how many lessons did I miss?". The query is self-scoped on the server: there
 * is no student argument, the rows come from the token.
 */
export const useMyAttendance = (groupId: string): IUseMyAttendance => {
  const { data, loading, error } = useStudentGroupAttendanceQuery({
    variables: { groupId },
    skip: !groupId,
    fetchPolicy: 'cache-and-network',
  });

  const attendance = useMemo(() => transformMyAttendance(data), [data]);

  return {
    attendance,
    loading: loading && !data,
    error: error?.message || '',
  };
};
